/* global axios */
import ApiClient from './ApiClient';

// Plantillas de Mensajes (Victor 2026-05-23) · módulo nuevo aislado.
class MessageTemplatesAPI extends ApiClient {
  constructor() {
    super('message_templates', { accountScoped: true });
  }

  // Registra el uso de una plantilla (auditoría → Informes). Fire-and-forget.
  recordUsage(id, payload) {
    return axios.post(`${this.url}/${id}/use`, payload);
  }
}

export default new MessageTemplatesAPI();
